import styled, { css } from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export const Wrapper = styled.div`
  width: 240px;
  height: 34px;
  position: relative;
  padding-left: 38px;
  background-color: ${({ theme }) => theme.colors.gray300};
  border-radius: 999px;
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: 8px;
  left: 14px;

  > * {
    vertical-align: top;
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 34px;
  line-height: 34px;
  background: none;
  border-width: 0;
  outline: 0;
  ${getFontStyle('midium150_C1')};

  &::placeholder {
    opacity: 1;
    color: ${({ theme }) => theme.colors.gray600};
  }
`;

export const inlineCss = css`
  position: static;
`;

export const listCss = css`
  position: absolute;
  width: 400px;
`;
